// Canonical subject identity is provided by the parent, never inferred from OCR names or devices.
export const CLINICAL_ORG = '河南省人民医院'
export const LAB_FIELDS = ['name', 'code', 'value', 'unit', 'referenceRange', 'flag']
export const EXAM_FIELDS = ['findings', 'conclusion', 'modality', 'bodyPart']
export const ORDER_FIELDS = ['treatment', 'drug', 'dose', 'route', 'frequency', 'start', 'end', 'status']
export const emptyClinicalRow = fields => Object.fromEntries(fields.map(key => [key, null]))
export const clinicalContextKey = (org, subjectId, site) => JSON.stringify([org, subjectId, site ?? ''])
export const cloneClinicalData = record => JSON.parse(JSON.stringify(record.confirmed_data ?? record.draft_data))

// Inputs remain strings (including <0.5 / qualitative laboratory values). Empty input is a deliberate clear.
export function clinicalConfirmationData(data) {
  const nullable = value => value === '' || value == null ? null : String(value)
  const fields = (value, keys) => value == null ? null : Object.fromEntries(keys.map(key => [key, nullable(value[key])]))
  return {
    type: data.type,
    ...fields(data, ['title', 'patientName', 'reportDate', 'rawText']),
    laboratory: data.laboratory == null ? null : { items: data.laboratory.items == null ? null : data.laboratory.items.map(row => fields(row, LAB_FIELDS)) },
    examination: fields(data.examination, EXAM_FIELDS),
    orders: data.orders == null ? null : data.orders.map(row => fields(row, ORDER_FIELDS)),
    warnings: [...data.warnings],
  }
}
export function clinicalFileError(file) {
  if (file.size > 10 * 1024 * 1024) return 'clinical_file_size'
  if (!/\.(png|jpe?g|pdf)$/i.test(file.name)) return 'clinical_file_type'
  return null // Server validates actual bytes; extension/MIME are not security boundaries.
}
export function validClinicalDate(value) {
  if (!value) return true
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value.startsWith('0000-')) return false
  const date = new Date(`${value}T00:00:00Z`)
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value
}
